<template>
  <div ref="layout" v-loading="loading" class="page-form">
    <affix v-if="!isEdit">
      <div class="tools">
        <form-button name="开始对账" type="primary" @click="changeStatus" />
      </div>
    </affix>

    <h3 class="title">安吉发货对账</h3>

    <div class="form-container">
      <el-form inline size="small" label-width="100px" :model="conditions" :disabled="isEdit">
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="对账起始日期">
              <el-date-picker
                v-model="conditions.startDate"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="对账结束日期">
              <el-date-picker
                v-model="conditions.endDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon
        title="明细"
        :custome-config="() => vxeShowCustom('xTable')"
      >
        <template #button>
          <table-button name="add" tip="确认对账" @click="tableEvent('del')" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          size="medium"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{name: 'NotData'}"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <!-- <template #toolbar /> -->
          <template v-for="item in gridOptions.columns" #[item.field]="{ row }">
            <div :key="item.field">
              <el-input
                v-if="gridOptions.columnsFieldTypes[item.field] == 'input'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="medium"
              />
              <el-select
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'planType'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="medium"
              >
                <el-option
                  v-for="items in selectDataOptions['A0002']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <el-select
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'stockType'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="medium"
              >
                <el-option
                  v-for="items in selectDataOptions['A0019']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <el-select
                v-else-if="gridOptions.columnsFieldTypes[item.field] == 'select' && item.field === 'invoiceNature'"
                v-model="row[item.field]"
                :disabled="isEdit"
                size="medium"
              >
                <el-option
                  v-for="items in selectDataOptions['A0032']"
                  :key="items.value"
                  :label="items.name"
                  :value="items.value"
                />
              </el-select>
              <span v-else>{{ row[item.field] }}</span>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <org-select v-if="dialogTitle === '营销中心'" ref="dialogSelect" />

        <client-select v-if="dialogTitle === '客户选择'" ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button type="default" icon="el-icon-circle-close" size="small" @click="showDialog = false">取消</el-button>
        <el-button type="primary" icon="el-icon-circle-check" size="small" @click="submitHandle">确认</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiFindAllClientInfo } from '@/api/common'
import { saveInvoiceFreeze, findInvoiceFreezeById, deleteInvoiceFreezeSub } from '@/api/applyForGoods/index'
import { mapGetters } from 'vuex'

const ClientSelect = () => import('@/components/dialog/ClientSelect.vue')
const OrgSelect = () => import('@/components/dialog/OrgSelect.vue')
export default {
  components: {
    ClientSelect,
    OrgSelect
  },
  data() {
    return {
      showDialog: false,
      dialogTitle: '客户选择',
      loading: false,
      id: '',
      conditions: {
        saleCenter: '',
        saleCenterView: '',
        customerCode: '',
        customerName: '',
        department: '',
        createdByName: '',
        createdDate: ''
      },
      validRules: {},
      selectDataOptions: {
        province: [],
        city: [],
        saleCenter: []
      },
      gridOptions: {
        buttons: [
          {
            label: '新增',
            type: 'add',
            icon: 'icon-add',
            style: 'primary'
          },
          {
            label: '删除',
            type: 'delete',
            icon: 'icon-delete',
            style: 'default'
          }
        ],
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'stockType', title: '发生日', slots: { default: 'stockType' }},
          { field: 'planType', title: '产品', slots: { default: 'planType' }},
          { field: 'invoiceNature', title: '发票开票量', slots: { default: 'invoiceNature' }},
          { field: 'leftQuantity', title: '安吉收票开票量', slots: { default: 'leftQuantity' }},
          { field: 'freezeQuantity', title: '申请发货量', slots: { default: 'freezeQuantity' }},
          { field: 'createdDate', title: '安吉发货量', slots: { default: 'createdDate' }},
          { field: 'remark', title: '相符', slots: { default: 'remark' }},
          { field: 'remark', title: '备注', slots: { default: 'remark' }}
        ],
        data: [],
        columnsFieldTypes: {
          stockType: 'select',
          planType: 'select',
          invoiceNature: 'select',
          freezeQuantity: 'input',
          remark: 'input'
        }
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sum() {
      const sum = this.gridOptions.data.reduce((p, c) => {
        return (+c.freezeQuantity) + p
      }, 0)
      return sum
    },
    isEdit() {
      return this.conditions.status === 1
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.initDetail()
    } else {
      this.conditions.createdDate = this.$utilsCommon.parseTime(
        new Date().getTime(),
        '{y}-{m}-{d}'
      )
      this.conditions.createdByName = this.userInfo.name
      this.conditions.department = this.userInfo.deptName
    }
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0032')
    this.getSelectDictDataOrigin('A0002')
  },
  methods: {
    initDetail() {
      this.loading = true
      findInvoiceFreezeById({ id: this.id }).then(res => {
        if (res?.status === 1) {
          Object.assign(this.conditions, res.data)
          this.gridOptions.data = res.data.list
        }
      }).catch(() => (this.loading = false)).finally(() => (this.loading = false))
    },
    changeStatus() {
      this.loading = true
      const params = {
        ...this.conditions,
        list: this.gridOptions.data
      }
      saveInvoiceFreeze(params).then(res => {
        if (res?.status === 1) {
          this.gridOptions.data = res.data.list
          Object.assign(this.conditions, res.data)
          this.$message.success('操作成功！')
        } else {
          this.$message.success('操作失败！')
        }
      }).catch(() => (this.loading = false)).finally(() => (this.loading = false))
    },
    changeCustomer(e) {
      if (!e) {
        this.conditions.customerCode = ''
        // this.selectDataOptions.saleCenter = []
      }
    },
    openDialog(e, title) {
      e.target.blur()
      this.showDialog = true
      this.dialogTitle = title
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()

      if (!data) return

      if (this.dialogTitle === '客户选择') {
        this.conditions.customerCode = data.customerCode
        this.conditions.customerName = data.customerName
        // this.selectDataOptions.saleCenter = data.clientOrgList
      } else {
        this.conditions.saleCenter = data.code
        this.conditions.saleCenterView = data.name
      }
      this.showDialog = false
    },
    tableEvent(btn) {
      if (btn === 'add') {
        this.insertData()
      } else {
        this.removeData()
      }
    },
    insertData() {
      const data = {
        id: '',
        stockType: '',
        leftQuantity: '',
        createdDate: this.$utilsCommon.parseTime(
          new Date().getTime(),
          '{y}-{m}-{d}'
        ),
        planType: '',
        invoiceNature: '',
        freezeQuantity: ''
      }
      this.gridOptions.data.unshift(data)
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      const hasIds = checkedList.filter(v => v.id)

      if (hasIds.length) {
        const ids = hasIds.map(v => v.id).join(',')
        await deleteInvoiceFreezeSub({ ids })
      }
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/logisticsReconciliation.vue